import React from "react";
import useSize from "../../../../Utils/useSize/useSize";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Statistics() {
  const windowSize = useSize();

  const navigate = useNavigate()

  const data = {
    symbol: "XAGUSD.",
    bid: 50.769,
    bidHigh: 51.14,
    bidLow: 50.403,
    ask: 50.779,
    askHigh: 51.15,
    askLow: 50.413,
    priceChange: "0.54%",
    buyVolume: "190K",
    sellVolume: "15K",
    openPrice: 50.497,
    closePrice: 50.497,
  };

  const rows = [
    { label: "Bid", value: data.bid, color: "text-blue-600" },
    { label: "Bid High", value: data.bidHigh },
    { label: "Bid Low", value: data.bidLow },
    { label: "Ask", value: data.ask, color: "text-blue-600" },
    { label: "Ask High", value: data.askHigh },
    { label: "Ask Low", value: data.askLow },
    { label: "Price Change", value: data.priceChange, color: "text-blue-600" },
    { label: "Buy Volume", value: data.buyVolume, color: "text-blue-600" },
    { label: "Sell Volume", value: data.sellVolume, color: "text-blue-600" },
    { label: "Open Price", value: data.openPrice },
    { label: "Close Price", value: data.closePrice },
  ];

  return (
    <div
      style={{ height: windowSize[1] - 100 }}
      className="bg-white text-black flex flex-col items-center font-sans"
    >
      {/* Header */}
      <div className="flex justify-between items-center w-full max-w-md px-4 py-3 border-b border-gray-100">
        <button
          onClick={() => navigate("-1")}
          className="w-9 h-9 rounded-full backdrop-blur-xl bg-white/60 flex items-center justify-center 
             shadow-[0_2px_10px_rgba(0,0,0,0.15)] 
             transition-transform duration-300 ease-in-out 
             hover:scale-105 active:scale-150"
        >
          <X className="text-black text-lg" />
        </button>
        <div className="text-xl semibold">{data.symbol}</div>
        <div className="w-6" /> {/* Spacer */}
      </div>

      {/* Table */}
      <div className="w-full max-w-md mt-2 text-[15px]">
        {rows.map((row, i) => (
          <div
            key={i}
            className={`flex justify-between px-4 py-2 ${
              i % 2 === 1 ? "bg-gray-50" : ""
            }`}
          >
            <span className="font-semibold">{row.label}</span>
            <span className={`${row.color || "text-black"}`}>{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}


